import React from 'react'

const TablaVerSuministrosDespachosQxFarmacia = ({item}) => {
  //useEffect(()=>{console.log(item,'itemmmmmmmmmmmmmmmmmmmmmmm')},[])
  return (
    <tbody>
      {/* {item.PaqAct === 'S'? */}
      <tr className=" divide-y divide-slate-700 ">
        <td></td>
        
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">          
          {item.MSRESO}
        </td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">          
          {item.MSNomG}
        </td>
        
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap ">          
          {item.PQCaSuSl}
        </td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap ">          
          {item.PQCaSuDs}
        </td>
        
      </tr>
      {/* :
      null

    } */}
    </tbody>
  )
}

export default TablaVerSuministrosDespachosQxFarmacia